import React, { ReactNode } from 'react';
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export interface AppLinkProps extends Omit<MuiLinkProps, 'href'> {
    to?: string;
    href?: string;
    ignoreRouter?: boolean;
    children?: ReactNode;
}

const isExternalHref = (href?: string) =>
    !!href && (/^https?:/.test(href) || href.startsWith('mailto:'));

const AppLink = ({
    to,
    href,
    ignoreRouter,
    children,
    ...props
}: AppLinkProps) => {
    const target = href ?? to;

    if (target && !ignoreRouter && !isExternalHref(target)) {
        return (
            <MuiLink
                component={RouterLink}
                to={target}
                underline="hover"
                {...props}
            >
                {children}
            </MuiLink>
        );
    }

    if (target) {
        return (
            <MuiLink href={target} underline="hover" {...props}>
                {children}
            </MuiLink>
        );
    }

    return (
        <MuiLink component="button" underline="hover" {...props}>
            {children}
        </MuiLink>
    );
};

export default AppLink;
